var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1990_6821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 4.145L17.9861 0H10.0001C9.2045 0 8.44144 0.31607 7.87883 0.87868C7.31622 1.44129 7.00015 2.20435 7.00015 3V4H5.00015C4.2045 4 3.44144 4.31607 2.87883 4.87868C2.31622 5.44129 2.00015 6.20435 2.00015 7V24H18.0001V19H22.0001V4.145ZM16.0001 22H4.00015V7C4.00015 6.73478 4.10551 6.48043 4.29304 6.29289C4.48058 6.10536 4.73493 6 5.00015 6H7.00015V19H16.0001V22ZM9.00015 17V3C9.00015 2.73478 9.10551 2.48043 9.29304 2.29289C9.48058 2.10536 9.73493 2 10.0001 2H16.0001V6H20.0001V17H9.00015Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1990_6821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.16c6345e51c72443dbbbf9654c10a6ee.svg";
export { ForwardRef as ReactComponent };